module.exports = __webpack_public_path__ + "static/media/pet.fe0fb674.svg";